export const columnsToCSVFields = (columns) => [
  'id',
  ...new Set(
    columns.map(({ dataIndex }) =>
      typeof dataIndex === 'string' ? dataIndex : dataIndex.join('.')
    )
  ),
];

export const COLUMNS = 'COLUMNS';
